import React from 'react';

const EnterpriseJourney = () => {
    return (
        <div className="py-6 mobile-p-1">
            <div className="container text-center">
                <div className="mb-3 center mw-600px">
                    <h3 className="font-bold pb-3">The AA's Sustainability Journey so far</h3>
                </div>
                <div className="row text-left">
                    <div className="col-5 d-grid mb-3">
                        <div className="img-cover img-2">
                            <div className="mobile-show h-240px"></div>
                        </div>
                    </div>
                    <div className="col-7 d-grid py-4 mb-3">
                        <div className="mb-3">
                            <p>{`We understand that for many of our 1.7 million AA Members ensuring the Association puts sustainability at its core, by acting to improve the communities and environment in which we operate, is vital.`}</p>
                        </div>
                        <div className="mb-1">
                            <p>{`That's why we look at everything we do with a sustainability lens to ensure our actitivies demonstrate the care we show for our Environment, investment in our community by ensuring safer roads and drivers, fostering a diverse and inclusive AA through our Culture, and that our Operations use only what is needed, reducing our energy consumption and recycling where we can.`} </p>
                        </div>
                    </div>
                </div>
                <br className="mobile-hide" />
                <div className="row text-left">
                    <div className="col-7 d-grid py-4 mb-3">
                        <div className="mb-3">
                            <p>{`From introducing a free mobile EV charge breakdown service for AA Members in Wellington, to having a significant Road Safety Member Benefit which ensures safer driver and roads via AA Driving School programmes like AA Senior Driver, our support for SADD (Students Against Dangerous Driving) and our sponsorship of vital road safety projects through the AA Research Foundation, we're proud of our Sustainability journey so far and excited for what's to come.`}</p>
                        </div>
                        <div className="mb-3">
                            <p>{`Sustainability challenges relies on all of us to play our part, and only by working together we can bring about transformational change.`}</p>
                        </div>
                    </div>
                    <div className="col-5 d-grid mb-3">
                        <div className="img-cover img-3">
                            <div className="mobile-show h-240px"></div>
                        </div>
                    </div>
                </div>
                <br className="mobile-hide" />
                <div className="row text-left">
                    <div className="col-5 d-grid mb-3">
                        <div className="img-cover img-4">
                            <div className="mobile-show h-240px"></div>
                        </div>
                    </div>
                    <div className="col-7 d-grid py-4 mb-3">
                        <div className="mb-3">
                            <h4 className="font-bold">Join the roadtrip!</h4>
                            <p>Offset your driving emissions this June to win a sustainable Kiwi roadtrip - including a Tesla rental, climate-friendly hamper and fully funded itinerary of accommodation, meals and activities - showcasing the best of green tourism in NZ.
                            <br/><br/>
                            For a chance to win, you just need to turn your AA Smartfuel discounts to CarbonClick rewards in June.</p>
                            <div className="mb-3">
                            <a className="btn btn-secondary btn-lg font-bold" target="_blank" href={`http://carbonclick.com/roadtrip`}>
                                    <span>
                                        Learn More
                                    </span>
                                </a>
                            </div>
                            <p>Find out more about the competition and the amazing projects, restoring native NZ forest, that it supports. You’ll also find tips and tricks to help you start driving more sustainably this winter.</p>
                        </div>
                     
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnterpriseJourney;